// hooks/useFixedGridColumns.js
import { useRef } from 'react';

/**
 * Genera el array de columnas **una sola vez** y:
 *  - Elimina duplicados por `field`
 *  - Congela el resultado para evitar mutaciones accidentales
 *  - Devuelve SIEMPRE la misma referencia (previene bucles y columnas fantasma)
 *
 * Uso:
 *   const columns = useFixedGridColumns(() => ([ ... ]));
 */
export default function useFixedGridColumns(factory) {
  const ref = useRef(null);

  if (!ref.current) {
    const raw = factory();

    // Dedupe por field
    const seen = new Set();
    const unique = [];
    for (const c of raw) {
      const f = c?.field;
      if (!f || !seen.has(f)) {
        seen.add(f);
        unique.push(c);
      }
    }

    // Congelar para evitar mutaciones
    ref.current = Object.freeze(unique.map(Object.freeze));
  }

  return ref.current;
}
